import { KYMW4200Component } from './kymw4200.component';

/**
 * 商品マスタプルーフ一覧画面の値を管理するクラス
 *
 * @export KYMW4200Model
 * @class KYMW4200Model
 */
export class KYMW4200Model {

  kymw4200Component: KYMW4200Component;

  public candidateGoodsProofList: Array<any>;
  public fileUrl: string = null;
  public imageInfoList: Object;
  public totalNum: number = <number>0;
  public startDispNum: number = <number>0;
  public endDispNum: number = <number>0;
  public pageNo: number = <number>(1);                                          // ページ番号
  public sortKey: string = <string>'';                                          // ソートキー
  public orderKey: string = <string>'';                                         // 降順または昇順

  public btnOutputEnabled = Boolean(false);                            // 出力ボタン活性フラグ
  public btnAllSelectEnabled = Boolean(false);                         // 全選択ボタン活性フラグ
  public btnAllUnSelectEnabled = Boolean(false);                       // 全解除ボタン活性フラグ
  public btnBackEnabled = Boolean(false);                              // 前へボタン活性フラグ
  public btnNextEnabled = Boolean(false);                              // 次へボタン活性フラグ

  public colorList: Array<any> = new Array<any>();

  /**
   * 商品マスタプルーフ出力
   *
   * @param {*} data サーバから取得された<FileUrl>タグ
   * @memberof KYMW4200Model
   */
  public setCandidateGoodsProofList(data: any): void {
    // APIのレスポンスが０件の場合、空のデータを作成。
    // 件数が存在する場合レスポンスを取得する。
    if (data == null) {
      this.candidateGoodsProofList = new Array<any>();
    } else {
      this.candidateGoodsProofList = data.CandidateGoods;
    }

    const candidateGoodsProofList: Array<any> = new Array<any>();
    for (let i = Number(0); i < this.candidateGoodsProofList.length; i++) {
      const tmp = this.candidateGoodsProofList[i];
      tmp.TargetFlg = false;
      candidateGoodsProofList.push(tmp);
    }
    this.candidateGoodsProofList = candidateGoodsProofList;

    // ページ設定
    if (data == null) {
      this.totalNum = 0;                                                        // 総件数
      this.startDispNum = 0;                                                    // 開始件数
      this.endDispNum = 0;                                                      // 終了件数
    } else {
      this.totalNum = Number(data.TotalNum);                                 // 総件数
      this.startDispNum = Number(data.StartDispNum);                         // 開始件数
      this.endDispNum = Number(data.EndDispNum);                             // 終了件数
    }

    // ボタン制御
    // 一覧の総件数が１件以上の場合に出力・全選択・全解除ボタンを活性
    if (this.totalNum !== 0) {
      this.btnOutputEnabled = true;
      this.btnAllSelectEnabled = true;
      this.btnAllUnSelectEnabled = true;
    } else {
      this.btnOutputEnabled = false;
      this.btnAllSelectEnabled = false;
      this.btnAllUnSelectEnabled = false;
    }

    // ２ページ以上の場合に前へボタンを活性
    if (this.pageNo !== 1) {
      this.btnBackEnabled = true;
    } else {
      this.btnBackEnabled = false;
    }

    // 総件数より前の件数の場合に次へボタンを活性
    if (this.totalNum > this.endDispNum) {
      this.btnNextEnabled = true;
    } else {
      this.btnNextEnabled = false;
    }
  }

  /**
   * 全選択、全解除処理を行う
   *
   * @param {Boolean} selectFlg
   * @memberof KYMW4200Model
   */
  public updateAllSelect(selectFlg: boolean): void {
    if (selectFlg) {
      for (let i = Number(0); i < this.candidateGoodsProofList.length; i++) {
        const tmp: any = this.candidateGoodsProofList[i];
        tmp.TargetFlg = true;
      }
    } else {
      for (let i = Number(0); i < this.candidateGoodsProofList.length; i++) {
        const tmp: any = this.candidateGoodsProofList[i];
        tmp.TargetFlg = false;
      }
    }
  }

  /**
   * ファイル名取得
   *
   * @param {*} data
   * @memberof KYMW4200Model
   */
  public updateFileUrl(data: any): void {
    // レスポンスの内容からFilenameを取得
    this.fileUrl = data.FileName;
  }
}
